// extracted by mini-css-extract-plugin
module.exports = {"PromotionalPanel":"PromotionalPanel_PromotionalPanel__1YGd5"};